// extracted by mini-css-extract-plugin
module.exports = {"menu":"_2HcGU","button":"gsiDP","text":"Lh2pU","show":"ORdQy"};